"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const app_controller_1 = require("./app.controller");
const typeorm_1 = require("@nestjs/typeorm");
const app_service_1 = require("./app.service");
const typeorm_config_1 = require("../../../service-lib/src/lib/database/typeorm.config");
const tpa_module_1 = require("../../../org-service/src/app/tpa/tpa.module");
const contact_module_1 = require("./contact/contact.module");
const address_module_1 = require("./address/address.module");
const insurer_module_1 = require("./insurer/insurer.module");
const employee_module_1 = require("./employee/employee.module");
const comapny_module_1 = require("./company/comapny.module");
const service_communication_1 = require("../../../service-lib/src/lib/service-communication");
const environment_1 = require("../../../service-lib/src/lib/environment");
const master_module_1 = require("./master/master.module");
const look_up_module_1 = require("./look-up/look-up.module");
const file_upload_module_1 = require("./file-upload/file-upload.module");
const broker_module_1 = require("./broker/broker.module");
const service_lib_module_1 = require("../../../service-lib/src/lib/service-lib.module");
const localization_module_1 = require("./localization/localization.module");
let AppModule = class AppModule {
    constructor(serviceRegistrationService) {
        this.serviceRegistrationService = serviceRegistrationService;
    }
    async onModuleInit() {
        const serviceInfo = {
            name: "org-service",
            url: `${environment_1.ENV.URL_ORG_SERVICE}`,
            port: environment_1.ENV.PORT_ORG_SERVICE,
            healthCheck: "/health",
            status: "active",
        };
        await this.serviceRegistrationService.registerService(serviceInfo);
    }
};
exports.AppModule = AppModule;
exports.AppModule = AppModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [
            typeorm_1.TypeOrmModule.forRoot(typeorm_config_1.typeOrmConfig),
            contact_module_1.ContactModule,
            address_module_1.AddressModule,
            tpa_module_1.TpaModule,
            insurer_module_1.InsurerModule,
            employee_module_1.EmployeeModule,
            comapny_module_1.CompanyModule,
            master_module_1.MasterModule,
            look_up_module_1.LookUpModule,
            file_upload_module_1.FileUploadModule,
            broker_module_1.BrokerModule,
            service_lib_module_1.InsuranceWellnessHubServiceLibModule,
            localization_module_1.LocalizationModule,
        ],
        controllers: [app_controller_1.AppController],
        providers: [app_service_1.AppService, service_communication_1.ServiceRegistrationService],
    }),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof service_communication_1.ServiceRegistrationService !== "undefined" && service_communication_1.ServiceRegistrationService) === "function" ? _a : Object])
], AppModule);
